export default "import { RedactiveClient } from \"@redactive/redactive\";\n\nconst client = new RedactiveClient({\n  apiKey: \"{{apiKey}}\",\n});\n"